import { Component, OnInit, Inject } from '@angular/core';
import { UserAccessType, AuthorizedUserAccessType } from '../models/user.model';
import { UserServiceIdentity } from '../services/user.service';
import { DealershipService } from '../services/dealership.service';
import { DealershipOverview, DealerGroupV, JobsiteV, JobsiteOverviewModel } from '../models/dealership.model';
import { CustomerServiceIdentity } from '../services/customer.service';
import { AppService } from '../../../app.service';
import { CustomerOverview } from '../models/customer.model';
import { JobRole, User } from '../models/user.model';
import { NotificationsService } from 'angular2-notifications';
import { LanguageViewModel } from '../../preferences/models/preferences.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CryptoService } from '../../../services/crypto.service';
import { UserService } from '../../../shared/services/user.service';
@Component({
  selector: 'edit-user-modal',
  templateUrl: './edit-user-modal.component.html',
  styleUrls: ['./edit-user-modal.component.scss']
})
export class EditUserModalComponent implements OnInit {
  userId: number;
  savingNewUser: boolean = false;
  accessTypes: AuthorizedUserAccessType[];
  dealerships: DealershipOverview[];
  dealergroups: DealerGroupV[];
  jobsites: JobsiteOverviewModel[];
  customers: CustomerOverview[];
  jobRoles: JobRole[];
  email: string = '';
  name: string = '';
  username: string = '';
  phone: string = '';
  selectedCustomerId: number = 0;
  selectedDealershipId: number = 0;
  selectedDealerGroupId: number = 0;
  selectedJobsiteId: number = 0;
  loadingCurrentDetails: boolean = true;
  password: string = '';
  USI: string = ''
  selectedLanguageId: number;
  userInitals: string = '';
  allowCheckUndercarriageAccess: boolean = false;
  allowCheckGetAccess: boolean = false;

  undercarriageEnabled: boolean = false;
  getEnabled: boolean = false;
  safetyEnabled: boolean = false;
  userAccessType: UserAccessType;
  selectedAccessTypeId: number;
  selectCustomerRequired: boolean = false;
  selectDealershipRequired: boolean = false;
  selectAccessToCustomersRequired: boolean = false;
  selectDealershipGroupRequired: boolean = false;
  selectJobsiteRequired: boolean = false;

  languagesList: LanguageViewModel[];
  customerAccessDropdownList = [];
  customerAccessDropdownSettings = {
    singleSelection: false,
    text: "Select Customers",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "multiselect-dropdown",
    maxHeight: 150,
    badgeShowLimit: 6
  };
  customerAccessSelectedItems = [];

  jobRoleDropdownList = [];
  jobRoleDropdownSettings = {
    singleSelection: false,
    text: "Select Job Roles",
    selectAllText: 'Select All',
    unSelectAllText: 'Un-select All',
    enableSearchFilter: true,
    classes: "multiselect-dropdown",
    maxHeight: 150,
    badgeShowLimit: 8
  };
  jobRoleSelectedItems = [];
  ShowAlertTab: number = 1;
  loginMethod: string = "Default";
  showLoginMethod: boolean = false;
  SSOEnabled: boolean = false;

  constructor(public dialogRef: MatDialogRef<EditUserModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private _userService: UserServiceIdentity,
    private _dealershipService: DealershipService, private _customerService: CustomerServiceIdentity, private _appService: AppService,
    private _notification: NotificationsService,
    private crypto: CryptoService, private _user: UserService) { }
  ngOnInit() {
    if (this.data != null) {
      this.userId = this.data.userId;
    }

    this._userService.getAllLanguages().subscribe(result => {
      this.languagesList = result;
    });
    this.checkPermissions();
    this._userService.getUserAccessType().subscribe(response => {
      this.userAccessType = response;
      this._userService.getAuthorizedUserAccessTypes().subscribe(response => {
        this.accessTypes = response;
        this._dealershipService.getAllDealerships().subscribe(response => {
          this.dealerships = response;
          this._customerService.getAllCustomers().subscribe(response => {
            this.customers = response;
            this._userService.getAssignableJobRoles().subscribe(response => {
              response.forEach(r => {
                this.jobRoleDropdownList.push({
                  "id": r.Id,
                  "itemName": r.Name
                });
              });
              this.handleCheckApplicationAccessAndLoadUserDetails();
            });
          });
        });
        this._dealershipService.getAllDealerGroups().subscribe(response => {
          this.dealergroups = response;
        });

        this._dealershipService.getAllJobsites().subscribe(response => {
          this.jobsites = response;
        });
      });
    });

    this.ShowSignInMethodOptions();

  }

  ShowSignInMethodOptions() {
    this._appService.getApplicationConfiguration("ShowSignInMethodOptions").subscribe(result => {
      this.showLoginMethod = result;
      if (result) {
        this._appService.SSOEnabled().subscribe(result => {
          this.SSOEnabled = result;
        });
      }
    });
  }


  DeafultUCSetupType: number;
  showAlertFiled: boolean = false;
  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case 'Inspectors':
              this.showAlertFiled = true;
              break;
            case 'Interpreters':
            case 'Super User':
            case 'Administrator':


              break;
            case 'Customer Admin':

              break;
          }
        });
      },
      error => {
        console.error(error);

      }
    );
  }
  loadUserDetails() {
    this._userService.getUserDetails(this.userId).subscribe(response => {
      console.log("response", response);
      //AES256
      this.email = this.crypto.decrypt(response.Email);
      this.name = this.crypto.decrypt(response.Name);
      this.username = this.crypto.decrypt(response.UserName);
      this.phone = (response.Phone && response.Phone.trim().length > 0) ? this.crypto.decrypt(response.Phone) : '';
      //this.email = response.Email;
      //this.name = response.Name;
      //this.username = response.UserName;
      //this.phone = this.phone;
      this.undercarriageEnabled = response.UndercarriageEnabled;
      this.getEnabled = response.GetEnabled;
      this.safetyEnabled = response.safetyEnabled;
      this.selectedAccessTypeId = response.AccessTypeId;
      this.password = response.Password;
      this.USI = response.USI;
      this.selectedLanguageId = response.LanguageId;
      this.DeafultUCSetupType = response.UCSetupType;
      this.userInitals = response.UserInitials;
      this.ShowAlertTab = response.ShowAlertTab ? 0 : 1;
      if (response.AccessTypeId == UserAccessType.DealershipAdministrator || response.AccessTypeId == UserAccessType.DealershipUser) {
        this.selectDealershipRequired = true;
        this.selectedDealershipId = response.DealershipId;
      }
      else if (response.AccessTypeId == UserAccessType.CustomerAdministrator || response.AccessTypeId == UserAccessType.CustomerUser) {
        this.selectCustomerRequired = true;
        this.selectedCustomerId = response.CustomerId;
      }
      if (response.AccessTypeId == UserAccessType.DealershipUser) {
        //this.selectAccessToCustomersRequired = true;
      }

      this.jobRoleSelectedItems = response.JobRoles.map(x => x.id);
      this.loadingCurrentDetails = false;
      this.loginMethod = response.SigninMethod;
    });
  }

  updateRequiredSelections() {
    if (this.selectedAccessTypeId == UserAccessType.GlobalAdministrator.valueOf()) {
      this.selectCustomerRequired = false;
      this.selectDealershipRequired = false;
      this.selectAccessToCustomersRequired = false;
      this.selectDealershipGroupRequired = false;
      this.selectJobsiteRequired = false;
    } else if (this.selectedAccessTypeId == UserAccessType.DealershipAdministrator.valueOf()) {
      this.selectCustomerRequired = false;
      this.selectDealershipRequired = false;
      this.selectDealershipGroupRequired = true;
      this.selectAccessToCustomersRequired = false;
      this.selectJobsiteRequired = false;
    } else if (this.selectedAccessTypeId == UserAccessType.DealershipUser.valueOf()) {
      this.selectCustomerRequired = false;
      this.selectDealershipRequired = true;
      this.selectAccessToCustomersRequired = false;
      this.selectDealershipGroupRequired = false;
      this.selectJobsiteRequired = false;
    } else if (this.selectedAccessTypeId == UserAccessType.CustomerAdministrator.valueOf()) {
      this.selectCustomerRequired = true;
      this.selectDealershipRequired = false;
      this.selectAccessToCustomersRequired = false;
      this.selectDealershipGroupRequired = false;
      this.selectJobsiteRequired = false;
    } else if (this.selectedAccessTypeId == UserAccessType.CustomerUser.valueOf()) {
      this.selectCustomerRequired = false;
      this.selectDealershipRequired = false;
      this.selectAccessToCustomersRequired = false;
      this.selectDealershipGroupRequired = false;
      this.selectJobsiteRequired = true;
    }
  }

  handleCheckApplicationAccessAndLoadUserDetails() {
    this._appService.getGetUrl().subscribe(response => {
      this.getEnabled = response.length > 0 ? true : false;
      this.allowCheckGetAccess = response.length > 0 ? true : false;
      this._appService.getUndercarriageUrl().subscribe(response => {
        this.undercarriageEnabled = response.length > 0 ? true : false;
        this.allowCheckUndercarriageAccess = response.length > 0 ? true : false;
        this.loadUserDetails();
      });
    });
  }

  onSelectDealership() {
    this._customerService.getAllCustomersForDealership(this.selectedDealershipId).subscribe(response => {
      this.customerAccessDropdownList = [];
      this.customerAccessSelectedItems = [];
      response.forEach(r => {
        this.customerAccessDropdownList.push({
          "id": r.CustomerId,
          "itemName": r.CustomerName
        });
      });
    })
  }
  Validate(event: any) {
    console.log("Event", event)
    var regex = new RegExp("^[0-9-()+ ]");
    var key = String.fromCharCode(event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  }
  updateUser() {
    if (this.savingNewUser)
      return;
    let newUser: User = {
      //AES256
      Name: this.crypto.encrypt(this.name?.trim()),
      UserName: this.crypto.encrypt(this.username?.trim()),
      Email: this.crypto.encrypt(this.email?.trim()),
      Phone: (this.phone && this.phone.trim().length > 0) ? this.crypto.encrypt(this.phone) : '',
      //   Name: this.name,
      //   UserName: this.username,
      //   Email: this.email,
      //   Phone: this.phone,
      AccessTypeId: this.selectedAccessTypeId,
      CustomerId: this.selectCustomerRequired ? this.selectedCustomerId : null,
      DealershipId: this.selectDealershipRequired ? this.selectedDealershipId : null,
      AccessCustomerIds: this.selectAccessToCustomersRequired ? this.customerAccessSelectedItems.map(c => c.id) : null,
      DealerGroupId: this.selectDealershipGroupRequired ? this.selectedDealerGroupId : null,
      JobsiteId: this.selectJobsiteRequired ? this.selectedJobsiteId : null,
      Id: this.userId,
      //JobRoles:this.jobRoleSelectedItems.length>0? this.jobRoleSelectedItems.map(c => c.id):[],
      JobRoles: this.jobRoleSelectedItems.length > 0 ? this.jobRoleSelectedItems : [],
      UndercarriageEnabled: this.undercarriageEnabled,
      GetEnabled: this.getEnabled,
      Password: '',
      StyleId: 0,
      safetyEnabled: this.safetyEnabled,
      USI: this.USI,
      LanguageId: this.selectedLanguageId,
      UCSetupType: this.DeafultUCSetupType,
      UserInitials: this.userInitals,
      ShowAlertTab: this.ShowAlertTab,
      SigninMethod: this.loginMethod
    };

    if (newUser.Name.length == 0 || newUser.UserName.length == 0 || newUser.Email.length == 0 || newUser.AccessTypeId == 0 ||
      (newUser.UndercarriageEnabled != true && newUser.GetEnabled != true && newUser.safetyEnabled != true)) {
      this._notification.error('Missing Required Field (*)', 'Please fill in all required fields before sending the invite. ');
      return;
    }
    /*
    if (newUser.AccessTypeId == 2 && newUser.DealerGroupId == 0) {
        this._notification.error('Missing Required Field (*)', 'Please fill in all required fields before sending the invite. ');
        return;
    }
    if (newUser.AccessTypeId == 3 && newUser.DealershipId == 0) {
        this._notification.error('Missing Required Field (*)', 'Please fill in all required fields before sending the invite. ');
        return;
    }
    if (newUser.AccessTypeId == 4 && (newUser.CustomerId == null || newUser.CustomerId == 0)) {
        this._notification.error('Missing Required Field (*)', 'Please fill in all required fields before sending the invite. ');
        return;
    }
    if (newUser.AccessTypeId == 5 && (newUser.JobsiteId == null || newUser.JobsiteId == 0)) {
        this._notification.error('Missing Required Field (*)', 'Please fill in all required fields before sending the invite. ');
        return;
    }
    */
    this.savingNewUser = true;
    this._userService.updateUser(newUser).subscribe(response => {
      this.savingNewUser = false;
      if (response.m_Item1) {
        this._notification.success('User Updated', 'The user has been updated successfully. ');
        this.dialogRef.close(true);
      } else {
        this._notification.error('Failed', response.m_Item2);
        console.log(response);
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  setInitialsFromName(): void {
    if (this.name) {
      const words = this.name.trim().split(/\s+/);
      this.userInitals = words.map(w => w[0]?.toUpperCase()).join('').slice(0, 2);
    }
  }
}
